import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enHomeDashboard from "../../locales/en/home-dashboard.json";
import enImageryQA from "../../locales/en/imagery-qa.json";
import ptHomeDashboard from "../../locales/pt/home-dashboard.json";
import enFieldsList from "../../locales/en/fields-list.json";
import ptFieldsList from "../../locales/pt/fields-list.json";
import insightsEn from "../../locales/en/insights.json";
import insightsPt from "../../locales/pt/insights.json";

import enCommon from "../../locales/en/common.json";
import enAccountSettings from "../../locales/en/account-settings.json";
import ptCommon from "../../locales/pt/common.json";
import ptAccountSettings from "../../locales/pt/account-settings.json";

import enOperations from "../../locales/en/operations.json";
import ptOperations from "../../locales/pt/operations.json";

import enMessages from "../../locales/en/messages.json";
import ptMessages from "../../locales/pt/messages.json";

import enSetup from "../../locales/en/setup.json";
import ptSetup from "../../locales/pt/setup.json";

import enRx from "../../locales/en/rx.json";
import ptRx from "../../locales/pt/rx.json";

import enField from "../../locales/en/field.json";
import ptField from "../../locales/pt/field.json";

import enHomeField from "../../locales/en/home-field.json";
import ptHomeField from "../../locales/pt/home-field.json";

const resources = {
    en: {
        common: enCommon,
        accountSettings: enAccountSettings,
        "home-dashboard": enHomeDashboard,
        "fields-list": enFieldsList,
        "imagery-qa": enImageryQA,
        insights: insightsEn,
        operations: enOperations,
        messages: enMessages,
        setup: enSetup,
        rx: enRx,
        field: enField,
        "home-field": enHomeField,
    },
    pt: {
        common: ptCommon,
        accountSettings: ptAccountSettings,
        "home-dashboard": ptHomeDashboard,
        "fields-list": ptFieldsList,
        insights: insightsPt,
        operations: ptOperations,
        messages: ptMessages,
        setup: ptSetup,
        rx: ptRx,
        field: ptField,
        "home-field": ptHomeField,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    keySeparator: ".",
    defaultNS: "common",
    ns: [
        "common",
        "accountSettings",
        "home-dashboard",
        "imagery-qa",
        "insights",
        "messages",
        "rx",
        "setup",
        "field",
        "home-field",
    ],
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});

export default i18n;
